export const ideaTypeList = [
  { value: 1, lable: 'banner' },
  { value: 2, lable: '开屏' },
  { value: 3, lable: '插屏' },
  { value: 4, lable: '原生' },
  { value: 5, lable: '激励视频' }
]

export const ideaTypeMap = {
  1: 'banner',
  2: '开屏',
  3: '插屏',
  4: '原生',
  5: '激励视频'
}
